/* eslint-disable import/no-anonymous-default-export */
export default {
  ac: 'C(C)=O',
  acac: 'C(=O)CC(C)=O',
  acet: 'C(C)=O',
  acm: 'CNC(C)=O',
  acnh: 'NC(C)=O',
  nhac: 'NC(C)=O',
  aco: 'OC(C)=O',
  oac: 'OC(C)=O',
  acoh: 'CC(O)=O',
  ad: 'C12CC3CC(C1)CC(C3)C2',
  adaarabif: 'O[C@H]1O[C@H](CO)[C@@H](O)[C@@H]1O',
  adallos: 'O[C@H]1O[C@H](CO)[C@@H](O)[C@@H](O)[C@H]1O',
  adaltro: 'O[C@H]1O[C@H](CO)[C@@H](O)[C@@H](O)[C@@H]1O',
  adarabip: 'O[C@H]1OC[C@@H](O)C(O)[C@@H]1O',
  aderyth: 'O[C@H]1OC[C@@H](O)[C@H]1O',
  adfruct: 'OC[C@]1(O)O[C@H](CO)[C@@H](O)[C@@H]1O',
  adgalac: 'O[C@H]1O[C@H](CO)[C@H](O)[C@H](O)[C@H]1O',
  adgluco: 'O[C@H]1O[C@H](CO)[C@@H](O)[C@H](O)[C@H]1O',
  adidose: 'O[C@H]1O[C@H](CO)[C@H](O)[C@@H](O)[C@@H]1O',
  adlyxof: 'O[C@H]1O[C@H](CO)[C@H](O)[C@@H]1O',
  adlyxop: 'O[C@H]1OC[C@@H](O)[C@H](O)[C@@H]1O',
  admanno: 'O[C@H]1O[C@H](CO)[C@@H](O)[C@H](O)[C@@H]1O',
  adpsico: 'OC[C@]1(O)O[C@H](CO)[C@@H](O)[C@H]1O',
  adribof: 'O[C@H]1O[C@H](CO)[C@@H](O)[C@H]1O',
  adribop: 'O[C@H]1OC[C@@H](O)[C@@H](O)[C@H]1O',
  adsorbo: 'OC[C@]1(O)O[C@H](CO)[C@H](O)[C@H]1O',
  adtagat: 'OC[C@]1(O)O[C@H](CO)[C@H](O)[C@@H]1O',
  adtalos: 'O[C@H]1O[C@H](CO)[C@H](O)[C@H](O)[C@@H]1O',
  adthreo: 'O[C@H]1OC[C@@H](O)[C@@H]1O',
  adxylof: 'O[C@H]1O[C@H](CO)[C@H](O)[C@H]1O',
  adxylop: 'O[C@H]1OC[C@@H](O)[C@H](O)[C@H]1O',
  alcl3: 'Cl[Al](Cl)Cl',
  all: 'CC=C',
  alloc: 'C(=O)OCC=C',
  allyl: 'CC=C',
  am: 'CCCCC',
  amnh: 'NCCCCC',
  nham: 'NCCCCC',
  amo: 'OCCCCC',
  oam: 'OCCCCC',
  amo2c: 'C(=O)OCCCCC',
  co2am: 'C(=O)OCCCCC',
  amooc: 'C(=O)OCCCCC',
  cooam: 'C(=O)OCCCCC',
  amp: 'NC1=C2N=CN([C@@H]3O[C@H](COP(O)(O)=O)[C@@H](O)[C@H]3O)C2=NC=N1',
  ams: 'SCCCCC',
  sam: 'SCCCCC',
  sac: 'SC(=O)C',
  acs: 'SC(=O)C',
  amyl: 'CCCCC',
  bdallos: 'O[C@@H]1O[C@H](CO)[C@@H](O)[C@@H](O)[C@H]1O',
  bdaltro: 'O[C@@H]1O[C@H](CO)[C@@H](O)[C@@H](O)[C@@H]1O',
  bdarabif: 'O[C@@H]1O[C@H](CO)[C@@H](O)[C@@H]1O',
  bdarabip: 'O[C@@H]1OC[C@@H](O)C(O)[C@@H]1O',
  bderyth: 'O[C@@H]1OC[C@@H](O)[C@H]1O',
  bdfruct: 'OC[C@@]1(O)O[C@H](CO)[C@@H](O)[C@@H]1O',
  bdgalac: 'O[C@@H]1O[C@H](CO)[C@H](O)[C@H](O)[C@H]1O',
  bdgluco: 'O[C@@H]1O[C@H](CO)[C@@H](O)[C@H](O)[C@H]1O',
  bdgulos: 'O[C@@H]1O[C@H](CO)[C@H](O)[C@@H](O)[C@H]1O',
  bdidose: 'O[C@@H]1O[C@H](CO)[C@H](O)[C@@H](O)[C@@H]1O',
  bdlyxof: 'O[C@@H]1O[C@H](CO)[C@H](O)[C@@H]1O',
  bdlyxop: 'O[C@@H]1OC[C@@H](O)[C@H](O)[C@@H]1O',
  bdmanno: 'O[C@@H]1O[C@H](CO)[C@@H](O)[C@H](O)[C@@H]1O',
  bdpsico: 'OC[C@@]1(O)O[C@H](CO)[C@@H](O)[C@H]1O',
  bdribof: 'O[C@@H]1O[C@H](CO)[C@@H](O)[C@H]1O',
  bdribop: 'O[C@@H]1OC[C@@H](O)[C@@H](O)[C@H]1O',
  bdsorbo: 'OC[C@@]1(O)O[C@H](CO)[C@H](O)[C@H]1O',
  bdtalos: 'O[C@@H]1O[C@H](CO)[C@H](O)[C@H](O)[C@@H]1O',
  bdthreo: 'O[C@@H]1OC[C@@H](O)[C@@H]1O',
  bdxylof: 'O[C@@H]1O[C@H](CO)[C@H](O)[C@H]1O',
  bdxylop: 'O[C@@H]1OC[C@@H](O)[C@H](O)[C@H]1O',
  benzoyl: 'C(=O)c1ccccc1',
  benzyl: 'Cc1ccccc1',
  bn: 'Cc1ccccc1',
  bnnh: 'NCC1=CC=CC=C1',
  nhbn: 'NCC1=CC=CC=C1',
  bno: 'OCC1=CC=CC=C1',
  obn: 'OCC1=CC=CC=C1',
  bno2c: 'C(=O)OCc1ccccc1',
  co2bn: 'C(=O)OCc1ccccc1',
  bnooc: 'C(=O)OCc1ccccc1',
  coobn: 'C(=O)OCc1ccccc1',
  boc: 'C(=O)OC(C)(C)C',
  bocnh: 'NC(=O)OC(C)(C)C',
  nhboc: 'NC(=O)OC(C)(C)C',
  bom: 'COCC1=CC=CC=C1',
  br2: 'BrBr',
  brosyl: 'S(=O)(=O)c1ccc(Br)cc1',
  bs: 'S(=O)(=O)c1ccc(Br)cc1',
  bt: 'N1N=NC2=CC=CC=C12',
  btm: 'CSC1=CC=CC=C1',
  bu: 'CCCC',
  bum: 'COC(C)(C)C',
  bu3sn: '[Sn](CCCC)(CCCC)CCCC',
  snbu3: '[Sn](CCCC)(CCCC)CCCC',
  bunh: 'NCCCC',
  nhbu: 'NCCCC',
  buo: 'OCCCC',
  obu: 'OCCCC',
  buo2c: 'C(=O)OCCCC',
  co2bu: 'C(=O)OCCCC',
  buooc: 'C(=O)OCCCC',
  coobu: 'C(=O)OCCCC',
  bus: 'SCCCC',
  sbu: 'SCCCC',
  bz: 'C(=O)c1ccccc1',
  bzl: 'Cc1ccccc1',
  bzo: 'OC(=O)C1=CC=CC=C1',
  obz: 'OC(=O)C1=CC=CC=C1',
  c10h21: 'CCCCCCCCCC',
  h21c10: 'CCCCCCCCCC',
  c11h23: 'CCCCCCCCCCC',
  h23c11: 'CCCCCCCCCCC',
  c12h25: 'CCCCCCCCCCCC',
  h25c12: 'CCCCCCCCCCCC',
  c13h27: 'CCCCCCCCCCCCC',
  h27c13: 'CCCCCCCCCCCCC',
  c14h29: 'CCCCCCCCCCCCCC',
  h29c14: 'CCCCCCCCCCCCCC',
  c15h31: 'CCCCCCCCCCCCCCC',
  h31c15: 'CCCCCCCCCCCCCCC',
  c16h33: 'CCCCCCCCCCCCCCCC',
  h33c16: 'CCCCCCCCCCCCCCCC',
  c17h35: 'CCCCCCCCCCCCCCCCC',
  h35c17: 'CCCCCCCCCCCCCCCCC',
  c18h37: 'CCCCCCCCCCCCCCCCCC',
  h37c18: 'CCCCCCCCCCCCCCCCCC',
  c19h39: 'CCCCCCCCCCCCCCCCCCC',
  h39c19: 'CCCCCCCCCCCCCCCCCCC',
  c20h41: 'CCCCCCCCCCCCCCCCCCCC',
  h41c20: 'CCCCCCCCCCCCCCCCCCCC',
  c21h43: 'CCCCCCCCCCCCCCCCCCCCC',
  h43c21: 'CCCCCCCCCCCCCCCCCCCCC',
  c22h45: 'CCCCCCCCCCCCCCCCCCCCCC',
  h45c22: 'CCCCCCCCCCCCCCCCCCCCCC',
  c23h47: 'CCCCCCCCCCCCCCCCCCCCCCC',
  h47c23: 'CCCCCCCCCCCCCCCCCCCCCCC',
  c24h49: 'CCCCCCCCCCCCCCCCCCCCCCCC',
  h49c24: 'CCCCCCCCCCCCCCCCCCCCCCCC',
  c25h51: 'CCCCCCCCCCCCCCCCCCCCCCCCC',
  h51c25: 'CCCCCCCCCCCCCCCCCCCCCCCCC',
  c2h5: 'CC',
  h5c2: 'CC',
  c3h7: 'CCC',
  h7c3: 'CCC',
  c4h9: 'CCCC',
  h9c4: 'CCCC',
  c5h11: 'CCCCC',
  h11c5: 'CCCCC',
  c6h13: 'CCCCCC',
  h13c6: 'CCCCCC',
  c7h15: 'CCCCCCC',
  h15c7: 'CCCCCCC',
  c8h17: 'CCCCCCCC',
  h17c8: 'CCCCCCCC',
  c9h19: 'CCCCCCCCC',
  h19c9: 'CCCCCCCCC',
  cbr3: 'C(Br)(Br)Br',
  br3c: 'C(Br)(Br)Br',
  cbz: 'C(=O)OCc1ccccc1',
  cbznh: 'NC(=O)OCC1=CC=CC=C1',
  hncbz: 'NC(=O)OCC1=CC=CC=C1',
  'c-c10h19': 'C1CCCCCCCCC1',
  'c-c11h21': 'C1CCCCCCCCCC1',
  'c-c12h23': 'C1CCCCCCCCCCC1',
  'c-c13h25': 'C1CCCCCCCCCCCC1',
  'c-c14h27': 'C1CCCCCCCCCCCCC1',
  'c-c15h29': 'C1CCCCCCCCCCCCCC1',
  'c-c16h31': 'C1CCCCCCCCCCCCCCC1',
  'c-c17h33': 'C1CCCCCCCCCCCCCCCC1',
  'c-c18h35': 'C1CCCCCCCCCCCCCCCCC1',
  'c-c19h37': 'C1CCCCCCCCCCCCCCCCCC1',
  'c-c20h39': 'C1CCCCCCCCCCCCCCCCCCC1',
  'c-c21h41': 'C1CCCCCCCCCCCCCCCCCCCC1',
  'c-c22h43': 'C1CCCCCCCCCCCCCCCCCCCCC1',
  'c-c23h45': 'C1CCCCCCCCCCCCCCCCCCCCCC1',
  'c-c24h47': 'C1CCCCCCCCCCCCCCCCCCCCCCC1',
  'c-c25h49': 'C1CCCCCCCCCCCCCCCCCCCCCCCC1',
  'c-c5h9': 'C1CCCC1',
  'c-c6h11': 'C1CCCCC1',
  'c-c7h13': 'C1CCCCCC1',
  'c-c8h15': 'C1CCCCCCC1',
  'c-c9h17': 'C1CCCCCCCC1',
  ccl3: 'C(Cl)(Cl)Cl',
  cl3c: 'C(Cl)(Cl)Cl',
  cf3: 'C(F)(F)F',
  f3c: 'C(F)(F)F',
  chex: 'C1CCCCC1',
  cho: 'C=O',
  ohc: 'C=O',
  cl2: 'ClCl',
  clso2: 'S(=O)(=O)Cl',
  so2cl: 'S(=O)(=O)Cl',
  cn: 'C#N',
  nc: 'C#N',
  cp: '*.[CH-]1C=CC=C1 |c:1,3,m:0:4.3.5.1.2|',
  co2et: 'C(=O)OCC',
  eto2c: 'C(=O)OCC',
  co2h: 'C(=O)O',
  ho2c: 'C(=O)O',
  co2iam: 'C(=O)OCCC(C)C',
  iamo2c: 'C(=O)OCCC(C)C',
  'co2i-am': 'C(=O)OCCC(C)C',
  'i-amo2c': 'C(=O)OCCC(C)C',
  co2ibu: 'C(=O)OCC(C)C',
  ibuo2c: 'C(=O)OCC(C)C',
  'co2i-bu': 'C(=O)OCC(C)C',
  'i-buo2c': 'C(=O)OCC(C)C',
  co2me: 'C(=O)OC',
  meo2c: 'C(=O)OC',
  'co2n-am': 'C(=O)OCCCCC',
  'n-amo2c': 'C(=O)OCCCCC',
  'co2n-bu': 'C(=O)OCCCC',
  'n-buo2c': 'C(=O)OCCCC',
  co2neoam: 'C(=O)OCC(C)(C)C',
  neoamo2c: 'C(=O)OCC(C)(C)C',
  'co2neo-am': 'C(=O)OCC(C)(C)C',
  'neo-amo2c': 'C(=O)OCC(C)(C)C',
  'co2n-pr': 'C(=O)OCCC',
  'n-pro2c': 'C(=O)OCCC',
  co2ph: 'C(=O)Oc1ccccc1',
  pho2c: 'C(=O)Oc1ccccc1',
  co2pr: 'C(=O)OCCC',
  pro2c: 'C(=O)OCCC',
  'co2s-am': 'C(=O)OC(C)CCC',
  's-amo2c': 'C(=O)OC(C)CCC',
  co2sbu: 'C(=O)OC(C)CC',
  sbuo2c: 'C(=O)OC(C)CC',
  'co2s-bu': 'C(=O)OC(C)CC',
  's-buo2c': 'C(=O)OC(C)CC',
  co2tam: 'C(=O)OC(C)(C)CC',
  tamo2c: 'C(=O)OC(C)(C)CC',
  'co2t-am': 'C(=O)OC(C)(C)CC',
  't-amo2c': 'C(=O)OC(C)(C)CC',
  co2tbu: 'C(=O)OC(C)(C)C',
  tbuo2c: 'C(=O)OC(C)(C)C',
  'co2t-bu': 'C(=O)OC(C)(C)C',
  't-buo2c': 'C(=O)OC(C)(C)C',
  coa:
    'SCCNC(=O)CCNC(=O)[C@H](O)C(C)(C)COP(=O)(O)OP(=O)(O)OC[C@H]1O[C@@H](n2cnc3c(N)ncnc32)[C@H](O)[C@@H]1OP(=O)(O)O',
  cobr: 'C(=O)Br',
  broc: 'C(=O)Br',
  cobu: 'C(=O)CCCC',
  buoc: 'C(=O)CCCC',
  cocf3: 'C(=O)C(F)(F)F',
  f3coc: 'C(=O)C(F)(F)F',
  cocl: 'C(=O)Cl',
  cloc: 'C(=O)Cl',
  coet: 'C(=O)CC',
  etoc: 'C(=O)CC',
  cof: 'C(=O)F',
  foc: 'C(=O)F',
  coipr: 'C(=O)C(C)C',
  iproc: 'C(=O)C(C)C',
  come: 'C(C)=O',
  meoc: 'C(C)=O',
  conet2: 'C(=O)N(CC)CC',
  et2noc: 'C(=O)N(CC)CC',
  conh2: 'C(N)=O',
  nh2oc: 'C(N)=O',
  conhet: 'C(=O)NCC',
  etnhoc: 'C(=O)NCC',
  conhme: 'C(=O)NC',
  menhoc: 'C(=O)NC',
  conme2: 'C(=O)N(C)C',
  me2noc: 'C(=O)N(C)C',
  cooet: 'C(=O)OCC',
  etooc: 'C(=O)OCC',
  cooh: 'C(=O)O',
  hooc: 'C(=O)O',
  cooiam: 'C(=O)OCCC(C)C',
  iamooc: 'C(=O)OCCC(C)C',
  cooph: 'C(=O)Oc1ccccc1',
  phooc: 'C(=O)Oc1ccccc1',
  coosbu: 'C(=O)OC(C)CC',
  sbuooc: 'C(=O)OC(C)CC',
  coph: 'C(=O)c1ccccc1',
  phoc: 'C(=O)c1ccccc1',
  copr: 'C(=O)CCC',
  proc: 'C(=O)CCC',
  cosbu: 'C(=O)C(C)CC',
  sbuoc: 'C(=O)C(C)CC',
  'cos-bu': 'C(=O)C(C)CC',
  's-buoc': 'C(=O)C(C)CC',
  cosh: 'C(=O)S',
  hsoc: 'C(=O)S',
  cot: '*.c1ccc[cH-][cH-]cc1 |m:0:4.5.6.7.8.1.2.3|',
  cotbu: 'C(=O)C(C)(C)C',
  tbuoc: 'C(=O)C(C)(C)C',
  'cot-bu': 'C(=O)C(C)(C)C',
  't-buoc': 'C(=O)C(C)(C)C',
  cph3: 'C(c1ccccc1)(c1ccccc1)c1ccccc1',
  ph3c: 'C(c1ccccc1)(c1ccccc1)c1ccccc1',
  cmp: 'NC1=NC(=O)N(C=C1)[C@@H]1O[C@H](COP(O)(O)=O)[C@@H](O)[C@H]1O',
  cy: 'C1CCCCC1',
  dallos: 'OC[C@@H](O)[C@@H](O)[C@@H](O)[C@@H](O)C=O',
  daltro: 'OC[C@@H](O)[C@@H](O)[C@@H](O)[C@H](O)C=O',
  darabi: 'C(O)[C@@H](O)[C@@H](O)[C@H](O)C=O',
  dcm: 'ClCCl',
  dde: 'C(C)=C1C(=O)CC(C)(C)CC1=O',
  deae: 'CCN(CC)CC',
  deips: '[Si](CC)(CC)C(C)C',
  deryth: 'OC[C@@H](O)[C@@H](O)C=O',
  derythu: 'C(O)[C@@H](O)C(=O)CO',
  dfruct: 'C(O)[C@@H](O)[C@@H](O)[C@H](O)C(=O)CO',
  dgalac: 'OC[C@@H](O)[C@H](O)[C@H](O)[C@@H](O)C=O',
  dgluco: 'OC[C@@H](O)[C@@H](O)[C@H](O)[C@@H](O)C=O',
  didose: 'OC[C@@H](O)[C@H](O)[C@@H](O)[C@H](O)C=O',
  dip: 'c1c(C(C)C)cccc1C(C)C',
  dlyxos: 'C(O)[C@@H](O)[C@H](O)[C@H](O)C=O',
  dmanno: 'OC[C@@H](O)[C@@H](O)[C@H](O)[C@H](O)C=O',
  dmf: 'CN(C)C=O',
  dmips: '[Si](C)(C)C(C)C',
  dmpm: 'CC1=CC=C(OC)C(OC)=C1',
  dmps: '[Si](C)(C)c1ccccc1',
  dms: 'CSC',
  dmso: 'CS(C)=O',
  dmt: 'C(c1ccccc1)(c1ccc(OC)cc1)c1ccc(OC)cc1',
  dmtr: 'C(c1ccccc1)(c1ccc(OC)cc1)c1ccc(OC)cc1',
  dnp: 'C1=C(N(=O)=O)C=C(N(=O)=O)C=C1',
  dns: 'S(=O)(=O)c1cccc2c(N(C)C)cccc12',
  dpips: '[Si](OC(C)C)(c1ccccc1)c1ccccc1',
  dpsico: 'C(O)C(=O)[C@H](O)[C@H](O)[C@H](O)CO',
  dptbs: '[Si](OC(C)(C)C)(c1ccccc1)c1ccccc1',
  dribos: 'C(O)[C@@H](O)[C@@H](O)[C@@H](O)C=O',
  dribul: 'C(O)[C@@H](O)[C@@H](O)C(=O)CO',
  dsorbo: 'C(O)C(=O)[C@H](O)[C@@H](O)[C@H](O)CO',
  dtagat: 'C(O)C(=O)[C@@H](O)[C@@H](O)[C@H](O)CO',
  dtalos: 'OC[C@@H](O)[C@H](O)[C@H](O)[C@H](O)C=O',
  dtbms: '[Si](C)(C(C)(C)C)C(C)(C)C',
  dthreo: 'OC[C@@H](O)[C@H](O)C=O',
  dxylos: 'C(O)[C@@H](O)[C@H](O)[C@@H](O)C=O',
  dxylul: 'C(O)[C@@H](O)[C@H](O)C(=O)CO',
  et: 'CC',
  et2n: 'N(CC)CC',
  net2: 'N(CC)CC',
  et3n: 'N(CC)(CC)CC',
  net3: 'N(CC)(CC)CC',
  'et3n+': '[N+](CC)(CC)CC',
  'n+et3': '[N+](CC)(CC)CC',
  etnh: 'NCC',
  hnet: 'NCC',
  eto: 'OCC',
  oet: 'OCC',
  farnesyl: 'CC=C(/C)CCC=C(/C)CCC=C(C)C',
  fmoc: 'C(=O)OCC1c2ccccc2-c2ccccc21',
  for: 'C=O',
  gmp: 'NC1=NC(=O)C2=C(N1)N(C=N2)[C@@H]1O[C@H](COP(O)(O)=O)[C@@H](O)[C@H]1O',
  h2: '[H][H]',
  h2nso2: 'S(N)(=O)=O',
  so2nh2: 'S(N)(=O)=O',
  h2o: '[H]O[H]',
  'h2o+': '[OH2+]',
  'o+h2': '[OH2+]',
  h2o2: 'OO',
  h2so4: 'OS(O)(=O)=O',
  hex: 'CCCCCC',
  hno2: 'ON=O',
  hno3: 'O[N+]([O-])=O',
  honh: 'NO',
  hnon: 'NO',
  hpo4: 'OP([O-])([O-])=O',
  h2po4: 'OP(O)([O-])=O',
  hso4: 'OS([O-])(=O)=O',
  i2: 'II',
  iam: 'CCC(C)C',
  'i-am': 'CCC(C)C',
  iamnh: 'NCCC(C)C',
  nhiam: 'NCCC(C)C',
  'i-amnh': 'NCCC(C)C',
  'nhi-am': 'NCCC(C)C',
  iamo: 'OCCC(C)C',
  oiam: 'OCCC(C)C',
  'i-amo': 'OCCC(C)C',
  'oi-am': 'OCCC(C)C',
  'i-amooc': 'C(=O)OCCC(C)C',
  'cooi-am': 'C(=O)OCCC(C)C',
  iams: 'SCCC(C)C',
  siam: 'SCCC(C)C',
  'i-ams': 'SCCC(C)C',
  'si-am': 'SCCC(C)C',
  ibu: 'CC(C)C',
  'i-bu': 'CC(C)C',
  ibuooc: 'C(=O)OCC(C)C',
  cooibu: 'C(=O)OCC(C)C',
  'i-buooc': 'C(=O)OCC(C)C',
  'cooi-bu': 'C(=O)OCC(C)C',
  'i-c3h7': 'C(C)C',
  'i-c4h9': 'CC(C)C',
  'i-c5h11': 'CCC(C)C',
  ipr: 'C(C)C',
  'i-pr': 'C(C)C',
  iprnh: 'NC(C)C',
  nhipr: 'NC(C)C',
  'i-prnh': 'NC(C)C',
  'nhi-pr': 'NC(C)C',
  ipro: 'OC(C)C',
  oipr: 'OC(C)C',
  'i-pro': 'OC(C)C',
  'oi-pr': 'OC(C)C',
  ipro2c: 'C(=O)OC(C)C',
  co2ipr: 'C(=O)OC(C)C',
  'i-pro2c': 'C(=O)OC(C)C',
  'co2i-pr': 'C(=O)OC(C)C',
  iprooc: 'C(=O)OC(C)C',
  cooipr: 'C(=O)OC(C)C',
  'i-prooc': 'C(=O)OC(C)C',
  'cooi-pr': 'C(=O)OC(C)C',
  iprs: 'SC(C)C',
  sipr: 'SC(C)C',
  'i-prs': 'SC(C)C',
  'si-pr': 'SC(C)C',
  ips: 'S(=O)(=O)c1ccc(I)cc1',
  kmno4: '[K+].[O-][Mn](=O)(=O)=O',
  kno2: '[K+].[O-]N=O',
  kno3: '[K+].[O-][N+]([O-])=O',
  mal: 'C(=O)/C=CC(=O)O',
  mdips: '[Si](C)(C(C)C)C(C)C',
  mdps: '[Si](C)(c1ccccc1)c1ccccc1',
  me: 'C',
  me2n: 'N(C)C',
  nme2: 'N(C)C',
  me3n: 'CN(C)C',
  'me3n+': '[N+](C)(C)C',
  'n+me3': '[N+](C)(C)C',
  mem: 'COCCOC',
  menh: 'NC',
  hnme: 'NC',
  meo: 'OC',
  ome: 'OC',
  meooc: 'C(=O)OC',
  coome: 'C(=O)OC',
  mes: 'SC',
  mgbr: '[Mg]Br',
  brmg: '[Mg]Br',
  mgcl: '[Mg]Cl',
  clmg: '[Mg]Cl',
  mmt: 'C(c1ccccc1)(c1ccccc1)c1ccc(OC)cc1',
  mmtr: 'C(c1ccccc1)(c1ccccc1)c1ccc(OC)cc1',
  mno2: 'O=[Mn]=O',
  mom: 'COC',
  mpm: 'CC1=CC=C(OC)C=C1',
  ms: 'S(C)(=O)=O',
  msm: 'CSC',
  mso: 'OS(C)(=O)=O',
  oms: 'OS(C)(=O)=O',
  'm-tol': 'c1cccc(C)c1',
  'm-tolyl': 'c1cccc(C)c1',
  mtr: 'S(=O)(=O)c1c(C)cc(OC)c(C)c1C',
  mtt: 'C(c1ccccc1)(c1ccccc1)c1ccc(C)cc1',
  n2: '[N+]#N',
  n3: 'N=[N+]=[N-]',
  'n-am': 'CCCCC',
  'n-amnh': 'NCCCCC',
  'nhn-am': 'NCCCCC',
  'n-amo': 'OCCCCC',
  'on-am': 'OCCCCC',
  'n-amooc': 'C(=O)OCCCCC',
  'coon-am': 'C(=O)OCCCCC',
  'n-ams': 'SCCCCC',
  'sn-am': 'SCCCCC',
  nano2: '[Na+].[O-]N=O',
  nano3: '[Na+].[O-][N+]([O-])=O',
  naph: 'C1=CC=CC2=C1C=CC=C2',
  nbs: 'BrN1C(=O)CCC1=O',
  'n-bu': 'CCCC',
  nbu4: 'CCCC[N+](CCCC)(CCCC)CCCC',
  'n-bunh': 'NCCCC',
  'nhn-bu': 'NCCCC',
  'n-buo': 'OCCCC',
  'on-bu': 'OCCCC',
  'n-buooc': 'C(=O)OCCCC',
  'coon-bu': 'C(=O)OCCCC',
  'n-bus': 'SCCCC',
  'sn-bu': 'SCCCC',
  'n-c3h7': 'CCC',
  'n-c4h9': 'CCCC',
  'n-c5h11': 'CCCCC',
  'n-c6h13': 'CCCCCC',
  nco: 'N=C=O',
  ocn: 'N=C=O',
  ncs: 'N=C=S',
  scn: 'N=C=S',
  neoam: 'CC(C)(C)C',
  'neo-am': 'CC(C)(C)C',
  neoamnh: 'NCC(C)(C)C',
  hnneoam: 'NCC(C)(C)C',
  'neo-amnh': 'NCC(C)(C)C',
  'nhneo-am': 'NCC(C)(C)C',
  neoamo: 'OCC(C)(C)C',
  oneoam: 'OCC(C)(C)C',
  'neo-amo': 'OCC(C)(C)C',
  'oneo-am': 'OCC(C)(C)C',
  neoamooc: 'C(=O)OCC(C)(C)C',
  cooneoam: 'C(=O)OCC(C)(C)C',
  'neo-amooc': 'C(=O)OCC(C)(C)C',
  'cooneo-am': 'C(=O)OCC(C)(C)C',
  neoams: 'SCC(C)(C)C',
  sneoam: 'SCC(C)(C)C',
  'neo-ams': 'SCC(C)(C)C',
  'sneo-am': 'SCC(C)(C)C',
  'neo-c5h11': 'CC(C)(C)C',
  net4: 'CC[N+](CC)(CC)CC',
  buhn: 'NCCCC',
  nhcbz: 'NC(=O)OCC1=CC=CC=C1',
  nhet: 'NCC',
  ethn: 'NCC',
  'n-hex': 'CCCCCC',
  nhme: 'NC',
  mehn: 'NC',
  nhneoam: 'NCC(C)(C)C',
  nhoh: 'NO',
  hohn: 'NO',
  nhph: 'NC1=CC=CC=C1',
  phhn: 'NC1=CC=CC=C1',
  nhpr: 'NCCC',
  prhn: 'NCCC',
  'nhs-am': 'NC(C)CCC',
  's-amnh': 'NC(C)CCC',
  nhtam: 'NC(C)(C)CC',
  tamnh: 'NC(C)(C)CC',
  'nht-am': 'NC(C)(C)CC',
  't-amnh': 'NC(C)(C)CC',
  nhtos: 'NS(=O)(=O)c1ccc(C)cc1',
  toshn: 'NS(=O)(=O)c1ccc(C)cc1',
  nhts: 'NS(=O)(=O)c1ccc(C)cc1',
  tshn: 'NS(=O)(=O)c1ccc(C)cc1',
  nhz: 'NC(=O)OCC1=CC=CC=C1',
  zhn: 'NC(=O)OCC1=CC=CC=C1',
  no: 'N=O',
  on: 'N=O',
  no2: '[N+]([O-])=O',
  o2n: '[N+]([O-])=O',
  no3: 'O[N+]([O-])=O',
  o3n: 'O[N+]([O-])=O',
  np: 'c1ccc([N+](=O)[O-])cc1',
  'n-pr': 'CCC',
  npro: 'OCCC',
  onpr: 'OCCC',
  'n-pro': 'OCCC',
  'on-pr': 'OCCC',
  o2: 'O=O',
  ok: '[O-].[K+]',
  ko: '[O-].[K+]',
  oli: '[O-].[Li+]',
  lio: '[O-].[Li+]',
  ona: '[O-].[Na+]',
  nao: '[O-].[Na+]',
  opr: 'OCCC',
  pro: 'OCCC',
  otips: 'O[Si](C(C)C)(C(C)C)C(C)C',
  tipso: 'O[Si](C(C)C)(C(C)C)C(C)C',
  'o-tol': 'c1ccccc1C',
  'o-tolyl': 'c1ccccc1C',
  otre: 'OCC(Cl)(Cl)Cl',
  treo: 'OCC(Cl)(Cl)Cl',
  ots: 'OS(=O)(=O)c1ccc(C)cc1',
  tso: 'OS(=O)(=O)c1ccc(C)cc1',
  'p+ph3': '[P+](c1ccccc1)(c1ccccc1)c1ccccc1',
  'ph3p+': '[P+](c1ccccc1)(c1ccccc1)c1ccccc1',
  pbf: '[SH](=O)(=O)c1c(C)c(C)c2c(c1C)CC(C)(C)O2',
  pbr3: 'P(Br)(BR)Br',
  pcl3: 'P(Cl)(Cl)Cl',
  pf6: '[P-](F)(F)(F)(F)(F)F',
  ph: 'C1=CC=CC=C1',
  ph3p: 'C1=CC=C(C=C1)P(C2=CC=CC=C2)C3=CC=CC=C3',
  '+pph3': '[P+](c1ccccc1)(c1ccccc1)c1ccccc1',
  phenyl: 'C1=CC=CC=C1',
  phnh: 'NC1=CC=CC=C1',
  pho: 'OC1=CC=CC=C1',
  oph: 'OC1=CC=CC=C1',
  phome: 'c1ccc(OC)cc1',
  meoph: 'c1ccc(OC)cc1',
  pi3: 'IP(I)I',
  piv: 'C(=O)C(C)(C)C',
  pmb: 'CC1=CC=C(OC)C=C1',
  pmc: 'S(=O)(=O)c1c(C)c(C)c2c(c1C)CCC(C)(C)O2',
  pmbm: 'COCC1=CC=C(OC)C=C1',
  pmp: 'c1ccc(OC)cc1',
  pnb: 'C(=O)c1ccc([N+](=O)[O-])cc1',
  po3: 'P(=O)([O-])[O-]',
  o3p: 'P(=O)([O-])[O-]',
  po3h: '[PH](=O)([O-])O',
  ho3p: '[PH](=O)([O-])O',
  po3h2: '[PH](=O)(O)O',
  h2o3p: '[PH](=O)(O)O',
  po4: '[O-]P([O-])([O-])=O',
  pobr3: 'BrP(Br)(Br)=O',
  poc: 'C(=O)OC1CCCC1',
  pocl3: 'ClP(Cl)(Cl)=O',
  'p(oet)2': 'P(OCC)OCC',
  '(eto)2p': 'P(OCC)OCC',
  poi3: 'IP(I)(I)=O',
  'p(ome)2': 'P(OC)OC',
  '(meo)2p': 'P(OC)OC',
  'po(oet)2': 'P(=O)(OCC)OCC',
  '(eto)2op': 'P(=O)(OCC)OCC',
  'po(ome)2': 'P(=O)(OC)OC',
  '(meo)2op': 'P(=O)(OC)OC',
  pph2: 'P(C1=CC=CC=C1)C2=CC=CC=C2',
  ph2p: 'P(C1=CC=CC=C1)C2=CC=CC=C2',
  pph3: 'C1=CC=C(C=C1)P(C2=CC=CC=C2)C3=CC=CC=C3',
  ppi: 'P(=O)([O-])OP(=O)([O-])[O-]',
  pip: 'P(=O)([O-])OP(=O)([O-])[O-]',
  pr: 'CCC',
  prnh: 'NCCC',
  prooc: 'C(=O)OCCC',
  coopr: 'C(=O)OCCC',
  prop: 'CCC',
  'p-tol': 'c1ccc(C)cc1',
  'p-tolyl': 'c1ccc(C)cc1',
  pv: 'C(=O)C(C)(C)C',
  py: 'C1=NC=CC=C1',
  pyrim: 'C1=NC=CC=N1',
  ring10: 'C1CCCCCCCCC1',
  ring11: 'C1CCCCCCCCCC1',
  ring12: 'C1CCCCCCCCCCC1',
  ring13: 'C1CCCCCCCCCCCC1',
  ring14: 'C1CCCCCCCCCCCCC1',
  ring15: 'C1CCCCCCCCCCCCCC1',
  ring16: 'C1CCCCCCCCCCCCCCC1',
  ring17: 'C1CCCCCCCCCCCCCCCC1',
  ring18: 'C1CCCCCCCCCCCCCCCCC1',
  ring19: 'C1CCCCCCCCCCCCCCCCCC1',
  ring20: 'C1CCCCCCCCCCCCCCCCCCC1',
  ring21: 'C1CCCCCCCCCCCCCCCCCCCC1',
  ring22: 'C1CCCCCCCCCCCCCCCCCCCCC1',
  ring23: 'C1CCCCCCCCCCCCCCCCCCCCCC1',
  ring24: 'C1CCCCCCCCCCCCCCCCCCCCCCC1',
  ring25: 'C1CCCCCCCCCCCCCCCCCCCCCCCC1',
  ring3: 'C1CC1',
  ring4: 'C1CCC1',
  ring5: 'C1CCCC1',
  ring6: 'C1CCCCC1',
  ring7: 'C1CCCCCC1',
  ring8: 'C1CCCCCCC1',
  ring9: 'C1CCCCCCCC1',
  's-am': 'C(C)CCC',
  's-amo': 'OC(C)CCC',
  'os-am': 'OC(C)CCC',
  's-amooc': 'C(=O)OC(C)CCC',
  'coos-am': 'C(=O)OC(C)CCC',
  's-ams': 'SC(C)CCC',
  'ss-am': 'SC(C)CCC',
  's-bu': 'C(C)CC',
  's-buo': 'OC(C)CC',
  'os-bu': 'OC(C)CC',
  's-buooc': 'C(=O)OC(C)CC',
  'coos-bu': 'C(=O)OC(C)CC',
  's-bus': 'SC(C)CC',
  'ss-bu': 'SC(C)CC',
  's-c5h11': 'C(C)CCC',
  sem: 'COCC[Si](C)(C)C',
  ses: 'S(=O)(=O)CC[Si](C)(C)C',
  set: 'SCC',
  ets: 'SCC',
  sime3: '[Si](C)(C)C',
  me3si: '[Si](C)(C)C',
  sime3o: 'O[Si](C)(C)C',
  ome3si: 'O[Si](C)(C)C',
  sme: 'SC',
  snme3: '[Sn](C)(C)C',
  me3sn: '[Sn](C)(C)C',
  clo2s: 'S(=O)(=O)Cl',
  h2no2s: 'S(N)(=O)=O',
  so3h: '[SH](=O)(=O)O',
  ho3s: '[SH](=O)(=O)O',
  so4: '[O-]S([O-])(=O)=O',
  sph: 'SC1=CC=CC=C1',
  phs: 'SC1=CC=CC=C1',
  spr: 'SCCC',
  prs: 'SCCC',
  suc: 'C(=O)CCC(=O)O',
  tam: 'C(C)(C)CC',
  't-am': 'C(C)(C)CC',
  tamo: 'OC(C)(C)CC',
  otam: 'OC(C)(C)CC',
  't-amo': 'OC(C)(C)CC',
  'ot-am': 'OC(C)(C)CC',
  tamooc: 'C(=O)OC(C)(C)CC',
  cootam: 'C(=O)OC(C)(C)CC',
  't-amooc': 'C(=O)OC(C)(C)CC',
  'coot-am': 'C(=O)OC(C)(C)CC',
  tams: 'SC(C)(C)CC',
  stam: 'SC(C)(C)CC',
  't-ams': 'SC(C)(C)CC',
  'st-am': 'SC(C)(C)CC',
  tbdms: '[SiH](C)(C)C(C)(C)C',
  tbdmso: 'O[Si](C)(C)C(C)(C)C',
  tbdps: '[Si](c1ccccc1)(c1ccccc1)C(C)(C)C',
  tbmps: '[Si](OC)(c1ccccc1)C(C)(C)C',
  tbs: '[SiH](C)(C)C(C)(C)C',
  tbso: 'O[Si](C)(C)C(C)(C)C',
  otbs: 'O[Si](C)(C)C(C)(C)C',
  tbt:
    'c1c(C([Si](C)(C)C)[Si](C)(C)C)cc(C([Si](C)(C)C)[Si](C)(C)C)cc1C([Si](C)(C)C)[Si](C)(C)C',
  tbu: 'C(C)(C)C',
  't-bu': 'C(C)(C)C',
  tbunh: 'NC(C)(C)C',
  nhtbu: 'NC(C)(C)C',
  't-bunh': 'NC(C)(C)C',
  'nht-bu': 'NC(C)(C)C',
  tbuo: 'OC(C)(C)C',
  otbu: 'OC(C)(C)C',
  't-buo': 'OC(C)(C)C',
  'ot-bu': 'OC(C)(C)C',
  tbuooc: 'C(=O)OC(C)(C)C',
  cootbu: 'C(=O)OC(C)(C)C',
  't-buooc': 'C(=O)OC(C)(C)C',
  'coot-bu': 'C(=O)OC(C)(C)C',
  tbus: 'SC(C)(C)C',
  stbu: 'SC(C)(C)C',
  't-bus': 'SC(C)(C)C',
  'st-bu': 'SC(C)(C)C',
  't-c4h9': 'C(C)(C)C',
  't-c5h11': 'C(C)(C)CC',
  't-c6h13': 'C(C)(C)C(C)C',
  tds: '[Si](C)(C)C(C)(C)C(C)C',
  tf: 'S(=O)(=O)C(F)(F)F',
  tfa: 'C(=O)C(F)(F)F',
  tfo: 'OS(=O)(=O)C(F)(F)F',
  otf: 'OS(=O)(=O)C(F)(F)F',
  thex: 'C(C)(C)C(C)C',
  't-hex': 'C(C)(C)C(C)C',
  thexyl: 'C(C)(C)C(C)C',
  thf: 'C1CCCO1',
  thp: 'C1CCCCO1',
  thpo: 'OC1CCCCO1',
  othp: 'OC1CCCCO1',
  thy: '[nH]1cc(C)c(=O)[nH]c1=O',
  tmp: 'CC1=CN([C@H]2C[C@H](O)[C@@H](COP(O)(O)=O)O2)C(=O)NC1=O',
  tips: '[Si](C(C)C)(C(C)C)C(C)C',
  tms: '[SiH](C)(C)C',
  tmso: 'O[Si](C)(C)C',
  otms: 'O[Si](C)(C)C',
  tmt: 'C(c1ccc(OC)cc1)(c1ccc(OC)cc1)c1ccc(OC)cc1',
  tol: 'c1ccc(C)cc1',
  tos: 'S(=O)(=O)c1ccc(C)cc1',
  tosnh: 'NS(=O)(=O)c1ccc(C)cc1',
  hntos: 'NS(=O)(=O)c1ccc(C)cc1',
  toso: 'OS(=O)(=O)c1ccc(C)cc1',
  otos: 'OS(=O)(=O)c1ccc(C)cc1',
  tosyl: 'S(=O)(=O)c1ccc(C)cc1',
  tpp: '[P+](c1ccccc1)(c1ccccc1)c1ccccc1',
  tpt: 'C12c3ccccc3C(c3ccccc31)c1ccccc12',
  tre: 'CC(Cl)(Cl)Cl',
  trityl: 'C(c1ccccc1)(c1ccccc1)c1ccccc1',
  troc: 'C(=O)OCC(Cl)(Cl)Cl',
  trt: 'C(c1ccccc1)(c1ccccc1)c1ccccc1',
  ts: 'S(=O)(=O)c1ccc(C)cc1',
  tsnh: 'NS(=O)(=O)c1ccc(C)cc1',
  hnts: 'NS(=O)(=O)c1ccc(C)cc1',
  u: 'O[C@H]1[C@@H](O)[C@@H](O[C@@H]1COP(O)(O)=O)N1C=CC(=O)NC1=O',
  ump: 'O[C@H]1[C@@H](O)[C@@H](O[C@@H]1COP(O)(O)=O)N1C=CC(=O)NC1=O',
  ura: '[nH]1ccc(=O)[nH]c1=O',
  z: 'C(=O)OCc1ccccc1',
  znh: 'NC(=O)OCC1=CC=CC=C1',
  hnz: 'NC(=O)OCC1=CC=CC=C1',
  'nhs-bu': 'NC(C)CC',
  's-bunh': 'NC(C)CC',
  co2k: 'C(=O)[O-]',
  co2na: 'C(=O)[O-]',
  cook: 'C(=O)[O-]',
  coona: 'C(=O)[O-]',
  sk: '[SH-]',
  sli: '[SH-]',
  sna: '[SH-]',
  abu: 'N(CCC)C(=O)',
  ade: 'N(C2=NC=N1)C=NC2=C1N',
  asu: 'NC(CCCCCC(O)=O)C(=O)',
  c10: 'CCCCCCCCCC',
  c11: 'CCCCCCCCCCC',
  c12: 'CCCCCCCCCCCC',
  c13: 'CCCCCCCCCCCCC',
  c14: 'CCCCCCCCCCCCCC',
  c15: 'CCCCCCCCCCCCCCC',
  c16: 'CCCCCCCCCCCCCCCC',
  c17: 'CCCCCCCCCCCCCCCCC',
  c18: 'CCCCCCCCCCCCCCCCC',
  c19: 'CCCCCCCCCCCCCCCCCC',
  c2: 'CC',
  c20: 'CCCCCCCCCCCCCCCCCCC',
  c21: 'CCCCCCCCCCCCCCCCCCCC',
  c22: 'CCCCCCCCCCCCCCCCCCCCC',
  c23: 'CCCCCCCCCCCCCCCCCCCCCC',
  c24: 'CCCCCCCCCCCCCCCCCCCCCCC',
  c25: 'CCCCCCCCCCCCCCCCCCCCCCCC',
  c3: 'CCC',
  c4: 'CCCC',
  c5: 'CCCCC',
  c6: 'CCCCCC',
  c7: 'CCCCCCC',
  c8: 'CCCCCCCC',
  c9: 'CCCCCCCCC',
  cyt: 'N(C=C1)C(=O)N=C1N',
  dtbs: 'C[Si](C(C)(C)C)(C(C)(C)C)C',
  glp: 'N1C(=O)CCC1C(=O)',
  gua: 'N2C=NC(C(=O)N1)=C2N=C1N',
  hcy: 'NC(CCS)C(=O)',
  hse: 'NC(CCO)C(=O)',
  'm-c6h4': 'C1=CC(=CC=C1)',
  'm-phenylene': 'C1=CC(=CC=C1)',
  nhsbu: 'NC(C)CC',
  sbunh: 'NC(C)CC',
  nle: 'NC(CCCC)C(=O)',
  nva: 'NC(CCC)C(=O)',
  'o-c6h4': 'C(C=CC=C1)=C1',
  'o-phenylene': 'C(C=CC=C1)=C1',
  orn: 'NC(CCCN)C(=O)',
  'p-c6h4': 'C1=CC=C(C=C1)',
  pht: 'C(=O)C1=CC=CC=C1C(=O)',
  'p-phenylene': 'C1=CC=C(C=C1)',
  sar: 'N(C)CC(=O)',
  tipds: '[Si](C(C)C)(C(C)C)O[Si](C(C)C)(C(C)C)',
  da: 'OC[C@H](O1)[C@@H](C[C@@H]1n1cnc2c(N)ncnc21)OP(=O)(O)',
  dc: 'OC[C@H](O1)[C@@H](C[C@@H]1n1ccc(N)nc1=O)OP(=O)(O)',
  dg: 'OC[C@H](O1)[C@@H](C[C@@H]1n1cnc2c(=O)[nH]c(N)nc21)OP(=O)(O)',
  dt: 'OC[C@H](O1)[C@@H](C[C@@H]1n1cc(C)c(=O)[nH]c1=O)OP(=O)(O)',
  co: 'C=O',
  oc: 'C=O',
  o: 'O',
  oh: 'O',
  h3co: 'OC',
  h_3co: 'OC',
  oo: 'OO',
  f3co: 'OC(F)(F)F',
  f_3co: 'OC(F)(F)F',
  d: '[2H]',
  ho: 'O',
  cd3: 'C',
  cd_3: 'C',
  d3c: 'C',
  d_3c: 'C',
  '-o': 'O',
  'o-': 'O',
  '-n': 'N',
  'n-': 'N',
  nh: 'N',
  nh2: 'N',
  nh_2: 'N',
  nh_3: 'N',
  nh3: 'N',
  h2n: 'N',
  h_2n: 'N',
  h_3n: 'N',
  hn: 'N',
  h3n: 'N',
  so2: 'S(=O)(=O)',
  so3: 'S(=O)(=O)(O)',
  so_2: 'S(=O)(=O)',
  so_3: 'S(=O)(=O)(O)',
  ch3: 'C',
  h3c: 'C',
  ch2: 'C',
  h2c: 'C',
  ch: 'C',
  hc: 'C',
  meo2s: 'S(=O)(=O)(C)',
  so2me: 'S(=O)(=O)(C)',
  ocf3: 'O(C(F)(F)F)',
  cf3o: 'O(C(F)(F)F)',
  'b(oh)2': 'B(OH)OH',
  nboc: 'NC(=O)OC(C)(C)C',
  cl: 'Cl',
  br: 'Br',
  nme: 'NC',
  otbdms: 'O([Si](C)(C)C(C)(C)(C))',
  hnch3: 'NC',
  nhch3: 'NC',
  och3: 'OC',
  ch3o: 'OC',
  nhoch3: 'NOC',
  nhnh2: 'NN',
  '(ho)2b': 'B(OH)OH',
  ochf2: 'OC(F)F',
  si: '[Si]',
  se: '[Se]',
  fe: '[Fe]',
  ca: '[Ca]',
  zn: '[Zn]',
  cu: '[Cu]',
  al: '[Al]',
  mg: '[Mg]',
  mn: '[Mn]',
  pt: '[Pt]',
  be: '[Be]',
  he: 'O',
  coch3: 'C(C)=O',
  'n-obu': 'OCCCC',
  't-obu': 'OC(C)(C)C',
  ccl2: 'C(Cl)Cl',
  cet: 'CCCCCCCCCCCCCCCCC',
  hep: 'CCCCCCC',
  non: 'CCCCCCCCC',
  oct: 'CCCCCCCC',
  pen: 'CCCCC',
  tfmes: 'S(=O)(=O)C(F)(F)F',
  tr: 'C(c1ccccc1)(c1ccccc1)c1ccccc1',
  und: 'CCCCCCCCCCC',
  '9-bbn': 'B1C2CCCC1CCC2',
  dan: 'S(=O)(=O)c1cccc2c(N(C)C)cccc12',
  val: 'C(=O)C(N)C(C)C',
  glu: 'C(=O)C(N)CCC(=O)O',
  tyr: 'C(=O)C(N)Cc1ccc(O)cc1',
  met: 'C(=O)C(N)CCSC',
  gln: 'C(=O)C(N)CCC(N)=O',
  trp: 'C(=O)C(N)Cc1c[nH]c2ccccc12',
  lys: 'C(=O)C(N)CCCCN',
  cys: 'C(=O)C(N)CS',
  thr: 'C(=O)C(N)C(C)O',
  leu: 'C(=O)C(N)CC(C)C',
  asp: 'C(=O)C(N)CC(=O)O',
  ser: 'C(=O)C(N)CO',
  iie: 'C(=O)C(N)C(C)CC',
  asn: 'C(=O)C(N)CC(N)=O',
  his: 'C(=O)C(N)Cc1cnc[nH]1',
  arg: 'C(=O)C(N)CCCNC(=N)N',
  phe: 'C(=O)C(N)Cc1ccccc1',
  gly: 'C(=O)CN',
  ala: 'C(=O)C(C)N',
  so2cf3: 'S(=O)(=O)C(F)(F)F',
  ocho: 'OC=O',
  opo2h2: 'OP(O)O',
  so2h: 'S(=O)O',
  ono2: 'O[N+](=O)[O-]',
  'co(t-bu)': 'C(=O)C(C)(C)C',
  'co(i-pr)': 'C(=O)C(C)C',
  ch2ph: 'Cc1ccccc1',
  'c(i-pr)3': 'C(C(C)C)(C(C)C)C(C)C',
  opo3h2: 'OP(=O)(O)O',
  c2h: 'C#C',
  'ch=chch3': 'OC=CC',
  'ch=chch2': 'OC=CC',
  'ch=ch2': 'C=C',
  'ch=ch': 'C=C',
  'n-c5': 'CCCCC',
  'n-c4': 'CCCC',
  'n-c3': 'CCC',
  nbn2: 'N(Cc1ccccc1)Cc1ccccc1',
  tbdpso: 'O[Si](c1ccccc1)(c1ccccc1)C(C)(C)C',
  omom: 'OCOC',
  '(ch2)8ch3': 'CCCCCCCCC',
  '(ch2)3co2ch2ccl3': 'CCCC(=O)OCC(Cl)(Cl)Cl',
  '(ch2)2c6h5': 'CCC#CC#CCC',
  '(ch2)2c16h5': 'CCC#CC#CC#CC#CC#CC#CC#CCC',
  '(ch2)19ch3': 'CCCCCCCCCCCCCCCCCCCC',
  '(ch2)13ch3': 'CCCCCCCCCCCCCC',
  c4h3: '/C=C/C#C',
  c3h3: 'CC#C',
  c2h3: 'C=C',
  c1h3: 'C',
  c18h11: 'c1ccc2cc3cc4ccccc4cc3cc2c1',
  c16h13: 'Cc1ccc2cc3ccc(C)cc3cc2c1',
  c16h11: 'c1ccc(-c2ccc3ccccc3c2)cc1',
  c12h25o: 'OCCCCCCCCCCCC',
  c12h11: 'CCc1ccc2ccccc2c1',
  'c(ch3)3': 'C(C)(C)C',
  so3na: 'S(=O)(=O)O[Na]',
  so2ph: 'S(=O)(=O)c1ccccc1',
  so2n3: '/N=N/N=S(=O)=O',
  ppr2: 'P(CCC)CCC',
  ppbo: '/P=P/B=O',
  'p(pr)2': 'P(CCC)CCC',
  oho: 'OO',
  ococh3: 'OC(C)=O',
  och2chch2: 'OCC=C',
  och2ch3: 'OCC',
  'och2ch(ch3)2': 'OCC(C)C',
  och: 'C=O',
  oc8h17: 'OCCCCCCCCCCCC',
  oc2h5: 'OCC',
  oc12h25: 'OCCCCCCCCCCCC',
  oboc: 'OC(=O)OC(C)(C)C',
  naoh: '[Na]',
  nao3s: 'SOOO[Na]',
  'n(ch2ch3)2': 'N(CC)CC',
  'n(ch2ch2ch2ch3)2': 'N(CCCC)CCCC',
  'n(c2h5)2': 'N(CC)CC',
  coochph2: 'C(=O)OC(c1ccccc1)c1ccccc1',
  cooch3: 'C(=O)OC',
  cooch2ch3: 'C(=O)OCC',
  'cooch2ch(ch3)2': 'C(=O)OCC(C)C',
  cooc2h5: 'C(=O)OCC',
  conhoh: 'C(=O)NO',
  conhch1chch2oh: 'C(=O)N/C=C/CO',
  co2chph2: 'C(=O)OC(c1ccccc1)c1ccccc1',
  co2ch3: 'C(=O)OC',
  'co2(ch2)11ch3': 'C(=O)OCCCCCCCCCCCC',
  ch3conh: 'NC(C)=O',
  ch2sime3: 'C[Si](C)(C)C',
  ch2oh: 'CO',
  ch2och3: 'COC',
  ch2ni: 'CN=[Y]',
  ch2nco: 'CN=C=O',
  ch2n: 'N=C',
  ch2cooh: 'CC(=O)O',
  'ch2cooch2ch(ch3)2': 'CC(=O)OCC(C)C',
  ch2ch3: 'CC',
  'ch2(ch2)4ch3': 'CCCCCC',
  'ch2(ch2)12ch3': 'CCCCCCCCCCCCCC',
  ch0: 'C=O',
  ccoch3: 'C#COC',
  sn: 'S#N',
  sipo: 'O[Si]#P',
  siph3: '[Si](c1ccccc1)(c1ccccc1)c1ccccc1',
  sh: 'S',
  sf5: 'S(F)(F)(F)(F)F',
  sf: 'SF',
  ru: '[Ru]',
  rh: '[Rh]',
  rg: '[Rg]',
  rf: '[Rf]',
  re: '[Re]',
  prh: 'P=[Rh]',
  po: 'P=O',
  pmbo: 'OCc1ccc(OC)cc1',
  pm: '[Pm]',
  pdh: '[PdH]',
  pd: '[Pd]',
  otr: 'OC(c1ccccc1)(c1ccccc1)c1ccccc1',
  otes: 'O[Si](CC)(CC)CC',
  oso3na: 'OS(=O)(=O)O[Na]',
  op: 'P=O',
  ooona: 'OOO[Na]',
  oooh: 'OOO',
  ooh: 'OO',
  obo: 'OB=O',
  oat: 'O[At]',
  o1h: 'O',
  noo: 'ON=O',
  nnh: 'N=N',
  nih: 'N=[YH]',
  ni: 'N=[Y]',
  nhso2ph: 'NS(=O)(=O)c1ccccc1',
  nhp: 'P=N',
  nhn: 'N=N',
  nhh: 'N',
  nhg: 'N=[Hg]',
  nhcoch3: 'NC(C)=O',
  nhb: 'B=N',
  nf2: 'N(F)F',
  neu: 'N=[Eu]',
  nd: '[Nd]',
  nch2: 'N=C',
  nbh: 'N=[Bh]',
  na: '.[Na+]',
  k: '.[K+]',
  li: '.[Li+]',
  ioc: 'C#[Y]=O',
  iico: 'OC#[Y]#[Y]',
  iic: 'C#[Y]#[Y]',
  hs: 'S',
  hpr: '[PrH]',
  hoo: 'OO',
  ho2o: 'OOO',
  hnh: 'N',
  hnb: 'B=N',
  hg: '[Hg]',
  hf: '[Hf]',
  hes: 'S#[He]',
  hbn: 'N=B',
  h5c6: 'CCCCCC',
  fs: 'SF',
  fo: 'OF',
  f3cs: 'SC(F)(F)F',
  f3co2s: 'SOOC(F)(F)F',
  eu: '[Eu]',
  cyo: 'OC1CCCCC1',
  cr: '[Cr]',
  chs: 'C#[Hs]',
  chg: 'C#[Hg]',
  cbo: 'OC#B',
  bo: 'B=O',
  bh2: 'B'
}
